import React from "react";
import style from "../styles/projects.module.css";
import { motion } from "framer-motion";
import {
  TbBrain,
  TbMicrophone,
  TbBrandGithub,
  TbCircleCheck,
  TbArrowUpRight,
  TbEye,
  TbFileText,
  TbWaveSine,
} from "react-icons/tb";
import { LuWorkflow } from "react-icons/lu";
import { TechIcon } from "./techIcons";
import { profile } from "../data/profile";

const projectIcons = {
  workflow: LuWorkflow,
  brain: TbBrain,
  mic: TbMicrophone,
  eye: TbEye,
  file: TbFileText,
  wave: TbWaveSine,
};

const Project = ({
  title,
  subTitle,
  period,
  icon,
  desc,
  techUsed,
  features,
  git,
  ind,
}) => {
  const Icon = projectIcons[icon] || LuWorkflow;

  return (
    <motion.article
      className={`project-card ${style.card}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.6, delay: ind * 0.08 }}
      whileHover={{ y: -8 }}
    >
      <span className={style.topLine} aria-hidden="true" />

      <div className={style.head}>
        <span className={style.icon}>
          <Icon />
        </span>
        <span className={style.period}>{period}</span>
      </div>

      <h3 className={`project-title ${style.title}`}>
        <span className={style.num}>0{ind + 1}</span> {title}
      </h3>
      <p className={style.subTitle}>{subTitle}</p>

      <div className={`project-description ${style.desc}`}>
        <p>{desc}</p>
      </div>

      {features.length > 0 && (
        <div className={style.features}>
          <h4 className={style.blockLabel}>Highlights</h4>
          <ul>
            {features.map((ele, i) => (
              <li key={i}>
                <TbCircleCheck className={style.tick} />
                <span>{ele}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className={style.bottom}>
        <div>
          <h4 className={style.blockLabel}>Tech Stack</h4>
          <div className={`project-tech-stack ${style.techDiv}`}>
            {techUsed.map((ele, i) => (
              <span key={i} className={style.chip}>
                <TechIcon name={ele} /> {ele}
              </span>
            ))}
          </div>
        </div>

        <a
          href={git || profile.githubUrl}
          target="_blank"
          rel="noreferrer"
          className={`project-github-link ${style.link}`}
        >
          <TbBrandGithub /> View on Github <TbArrowUpRight />
        </a>
      </div>
    </motion.article>
  );
};

export default Project;
